var map = {
	"./default/logo_rgb.png": [
		85403,
		85403
	],
	"./documentation/logo_rgb.png": [
		21978,
		21978
	],
	"./epista/logo_rgb.png": [
		38422,
		38422
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 71326;
module.exports = webpackAsyncContext;